var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dropdown',_vm._g(_vm._b({staticClass:"dropdown-plain",attrs:{"show-check-box":true,"no-all-controls":"","tags":false,"plain":"","selectionClass":"text-md text-gray-600 font-normal","custom-styles":""}},'Dropdown',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }